import UnitChip from "@/components/UnitChip"
import { Site } from "../model/site.types"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import siteStore from "../model/site.store"

interface Props {
  onAddClick?: () => void
  onClick?: () => void
  onRemoveClick?: () => void
  site: Site
}

export default function SiteChip(props: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const activeSite = useAppSelector(siteStore.selectors.active)
  const selected = useAppSelector(siteStore.selectors.selected)

  //Display active
  //Is selected in the list or is the active element
  const isActive = props.site.id === activeSite.id || (selected.includes(props.site.id) && !activeSite.EstablishmentId)

  return (
    <UnitChip
      isActive={isActive}
      onAddClick={isActive ? undefined : props.onAddClick}
      onClick={props.onClick ?? (() => dispatch(siteStore.actions.select(props.site.id)))}
      onRemoveClick={isActive ? props.onRemoveClick : undefined}
      unit={{ type: "site", site: props.site }}
    />
  )
}
